export function padCountdown(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

export function formatScheduleCountdown(totalSeconds: number): string {
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (days > 0) {
    return `${padCountdown(days)}d ${padCountdown(hours)}h ${padCountdown(minutes)}m`;
  }
  if (hours > 0) {
    return `${padCountdown(hours)}h ${padCountdown(minutes)}m ${padCountdown(seconds)}s`;
  }
  if (minutes > 0) {
    return `${padCountdown(minutes)}m ${padCountdown(seconds)}s`;
  }
  return `${padCountdown(seconds)}s`;
}

export function formatScheduleEventTime(eventTime: string): string {
  const [h, m] = eventTime.split(':');
  return `${(h ?? '00').padStart(2, '0')}:${(m ?? '00').padStart(2, '0')}`;
}
